import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onBeforeUnmount } from 'vue';

import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import Lightgallery from 'lightgallery/vue';

// eslint-disable-next-line import/extensions,import/no-unresolved
import { BeforeSlideDetail, InitDetail } from 'lightgallery/lg-events';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkGallery',
  props: {
  hidden: {
    type: Boolean,
    default: false,
  },
  settings: {
    type: Object,
    default: () => ({}),
  },
  hasMiniatur: {
    type: Boolean,
    default: false
  },
  allowDelete: {
    type: Boolean,
    default: false
  }
},
  emits: ['delete-image'],
  setup(__props, { expose, emit }) {

const props = __props


// DOC https://www.lightgalleryjs.com/docs/vue/


const instance = ref();
const plugins = [lgThumbnail, lgZoom];

const currentIndex = ref(0);


const triggerDelete = () => {
  emit('delete-image', { index: currentIndex.value })
}

let deleteBtn: HTMLButtonElement | null = null;

const onInit = ({ instance: _instance }: InitDetail) => {
  instance.value = _instance;

  const toolbar = document.querySelector('.lg-toolbar');

  if (props.allowDelete && toolbar && !deleteBtn) {
    deleteBtn = document.createElement('button');
    deleteBtn.type = 'button';
    deleteBtn.className = 'lg-icon';
    deleteBtn.title = 'Delete Image';
    deleteBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 256 256"><path d="M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z"></path></svg>`;

    deleteBtn.addEventListener('click', triggerDelete);
    toolbar.appendChild(deleteBtn);
  }
};

const onBeforeSlide = (detail : BeforeSlideDetail) => {
  currentIndex.value = detail.index;
}

expose({
  instance,
});

onBeforeUnmount(() => {
  if(deleteBtn) {
    deleteBtn.removeEventListener('click', triggerDelete);
    deleteBtn = null;
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Lightgallery), _mergeProps({
    class: ["light-gallery", {
      '!hidden': props.hidden,
      '!h-[56px]': props.hasMiniatur
    }],
    onInit: onInit,
    onBeforeSlide: onBeforeSlide,
    settings: {
      plugins: plugins,
      ...props.settings,
    }
  }, _ctx.$attrs), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class", "settings"]))
}
}

})